export default "__VITE_ASSET__tDG0xZs8__"